import React, { FormEvent, useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LibraryForm } from '../../../components/Library/LibraryForm'
import { LibraryHeader } from '../../../components/Library/LibraryHeader'
import { LibraryList } from '../../../components/Library/LibraryList'
import useApi from '../../../hooks/useApi'
import { SubmitButton } from '../../../Korbantech/components/Buttons/SubmitButton'
import { AdminLayout } from '../../../layout/AdminLayout'
import { Hint } from '../../../types/Hint'

export const Hints = ({ form }: Props) => {

    const api = useApi()
    const navigate = useNavigate()
    const [hints, setHints] = useState<Hint[]>([])

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        await api.post("/admin/library/hints", data).then(res => {
            navigate("/admin/biblioteca")
        }).catch(console.log)

    }, [api, navigate])

    const loadHints = useCallback(async () => {
        await api.get("/admin/library/hints").then(res => {
            setHints(res.data)
        }).catch(console.log)
    }, [api, setHints])

    useEffect(() => {
        loadHints()
    }, [loadHints])

    return (
        <AdminLayout>
            {form && <LibraryHeader page='Dica' form />}
            {!form && <LibraryHeader page='Dica' />}
            {form &&
                <div className='grid grid-cols-12 mb-6'>
                    <form onSubmit={handleSubmit} className='col-span-5 col-start-4 bg-white border-2 rounded-md mt-6 grid'>
                        <LibraryForm title={"Título"} image={"Imagem do card"}
                            description={"Descrição"} link="Link" />
                        <div className='col-span-3 px-6 mb-3'>
                            <SubmitButton value={"Adicionar Dica"} />
                        </div>
                    </form>
                </div>
            }
            {!form &&

                <div className='grid-cols-3 gap-x-4'>
                    <LibraryList type='hints'  libraryItem={hints} />
                </div>
            }
        </AdminLayout>
    )
}
interface Props {
    form?: boolean
}